import React from "react";
import { NumberFormat } from "./style";
import PropTypes from "prop-types";

export default function Format({ price }) {
    const Number = () => {
        var novoValor = new Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
        }).format(price);
        return <NumberFormat>{novoValor}</NumberFormat>;
    };

    return <Number></Number>;
}


Format.propTypes = {
    price: PropTypes.number,
};